declare const gtag: Function;

export default class PricingSection {

    element: HTMLElement

    constructor(element: HTMLElement) {
        new CurrencyChanger(element.querySelector('[data-toggle-currency]'));

        element.querySelectorAll('.pricing-plan').forEach((el: HTMLElement) => {
            el.addEventListener('mouseenter', () => {
                element.querySelectorAll('.pricing-plan').forEach((el: HTMLElement) => el.classList.remove('-highlight'));
                el.classList.add('-highlight');
            });
        });

        let toggleButton: HTMLElement = document.querySelector('.panel-plans-included .panel-plans-included__toggle');
        if (toggleButton) {
            toggleButton.addEventListener('click', (el) => (el.target as HTMLElement).remove());
        }
    }

}

class CurrencyChanger {

    currency: string
    element: HTMLElement
    prices: Array<PlanPrice>

    constructor(el: HTMLElement) {
        this.currency = '$';
        this.element = el;
        this.prices = [];

        document.querySelectorAll('.plan-price').forEach((el: HTMLElement) => {
            this.prices.push(new PlanPrice(el));
        });

        document.querySelectorAll('.pricing-plan').forEach((el: HTMLElement) => {
            let href = el.querySelector('a.btn');
            if (href) {
                el.classList.add('clickable');
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    if (typeof gtag === 'function') {
                        let data = {
                            currency: 'USD',
                            value: el.dataset.price,
                            items: [
                                {
                                    item_id: el.dataset.sku,
                                    quantity: 1,
                                    price: el.dataset.price,
                                }
                            ]
                        };

                        gtag('event', 'add_to_cart', data);
                    }

                    window.location.href = href.getAttribute('href')
                });
            }
        });

        this.initEvents();
    }

    isDollar(): boolean {
        return '$' === this.currency;
    }

    switchToEuro(): void {
        this.currency = '€';
        this.element.querySelectorAll('[data-currency-txt]').forEach((el: HTMLElement) => el.innerText = 'Dollars');
        this.element.querySelectorAll('[data-currency]').forEach((el: HTMLElement) => el.innerText = '$');
        this.prices.forEach(p => {
            p.switchToEuro();
        });
    }

    switchToDollar(): void {
        this.currency = '$';
        this.element.querySelectorAll('[data-currency-txt]').forEach((el: HTMLElement) => el.innerText = 'Euro');
        this.element.querySelectorAll('[data-currency]').forEach((el: HTMLElement) => el.innerText = '€');
        this.prices.forEach(p => {
            p.switchToDollar();
        });
    }

    initEvents(): void {
        this.element.addEventListener('click', e => {
            e.preventDefault();

            if (this.isDollar()) {
                this.switchToEuro()
                document.querySelectorAll('[data-currency-estimation]').forEach(element => element.classList.add('-visible'));
            } else {
                this.switchToDollar();
                document.querySelectorAll('[data-currency-estimation]').forEach(element => element.classList.remove('-visible'));
            }
        });
    }


}

class PlanPrice {
    element: HTMLElement

    constructor(element: HTMLElement) {
        this.element = element;
    }

    getDollarPrice(): number {
        return parseInt(this.element.querySelector<HTMLElement>('[data-dollar]').dataset.dollar);
    }

    switchToEuro() {
        this.element.querySelectorAll('[data-currency]').forEach((el: HTMLElement) => el.innerHTML = '&euro;');
        this.element.querySelectorAll('[data-amount]').forEach((el: HTMLElement) => el.innerText = dollarToEuro(this.getDollarPrice()));
    }

    switchToDollar() {
        this.element.querySelectorAll('[data-currency]').forEach((el: HTMLElement) => el.innerHTML = '$');
        this.element.querySelectorAll('[data-amount]').forEach((el: HTMLElement) => el.innerText = this.getDollarPrice().toString());
    }

}

const dollarToEuro = (dollar: number): string => {
    const rate = acp_exchange_rates
    const ratio = rate ? parseFloat(rate.ratio) : 1;

    return Math.round(dollar * ratio).toString();
}